import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPanel.css';
import { loginWithAccount, saveAccount, saveTokens, getCurrentUserInfo } from '../../services/authService';

function LoginPanel({ onLoginSuccess }) {
  const [inputAccount, setInputAccount] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // 生成 UUID 随机字符串
  const generateUuid = () => {
    if (window.crypto && window.crypto.randomUUID) {
      setInputAccount(window.crypto.randomUUID());
    } else {
      // 简单的 UUID v4 fallback 生成逻辑
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-mixed-operators
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
      setInputAccount(uuid);
    }
  };

  // 处理获取 Token 的请求
  const handleGetToken = async () => {
    if (!inputAccount) {
      alert('请输入账号');
      return;
    }

    try {
      const data = await loginWithAccount(inputAccount, password);
      // 存储 Token
      saveTokens(data.access_token, data.refresh_token);
      
      // 保存账号（可选，用于记住我）
      saveAccount(inputAccount);

      // 获取当前用户详细信息 (包括 UUID)
      try {
        await getCurrentUserInfo(inputAccount);
      } catch (userInfoError) {
        console.error('Failed to fetch user info after login:', userInfoError);
        // 这里可以选择是否阻断登录流程，通常为了稳健性，可以警告但允许继续，
        // 或者阻断。鉴于 UUID 是后续 WebSocket 必须的，建议在这里报错或重试。
        alert('登录成功，但获取用户信息失败，部分功能可能不可用。');
      }
      
      if (onLoginSuccess) {
        onLoginSuccess();
      }

    } catch (error) {
      console.error('Login failed:', error);
      alert(error.message || '登录失败，请检查账号密码');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">WebSocket Chat Portal</h1>
        
        <div className="input-group">
          <label className="input-label">User ID</label>
          <div className="input-wrapper">
            <input
              type="text"
              className="login-input"
              value={inputAccount}
              onChange={(e) => setInputAccount(e.target.value)}
              placeholder="输入账号 或生成随机 UUID"
            />
            <button 
              onClick={generateUuid}
              className="btn-icon"
              title="随机生成 UUID"
            >
              🎲
            </button>
          </div>
        </div>

        <div className="input-group">
          <label className="input-label">Password</label>
          <div className="input-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              className="login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="请输入密码"
            />
            <button 
              onClick={() => setShowPassword(!showPassword)}
              className="btn-icon"
              title={showPassword ? "隐藏密码" : "显示密码"}
              type="button" // 防止提交表单
            >
              {showPassword ? "🙈" : "👁️"}
            </button>
          </div>
        </div>

        <button 
          onClick={handleGetToken}
          className="btn-login"
        >
          登 录
        </button>
        
        <div className="login-footer">
          <span 
            className="link-back-home" 
            onClick={() => navigate('/')}
          >
            ← 返回主页
          </span>
        </div>
      </div>
    </div>
  );
}

export default LoginPanel;
